import { useEffect, useState } from "react";
import '../../assets/css/manage.css'
import '../../App.css'
import Input from "../../components/Input";
import Select from "../../components/Select";
import DataGridMUI from "../../components/DataGridMUI";
import axiosInstance from '../../api/axiosInstance'
import { REGEX } from "../../utils/regexConstants";
import { useNavigate } from "react-router-dom";
import Logout, { handleLogout } from "../../api/logout";
import MngrNavi from "./MngrNavi";
import local from "../../utils/local";
import { alert, confirm } from "../../utils/comm";

const DocMng = () => {
    const navigate = useNavigate();
    const [hasMounted, setHasMounted] = useState(false); // 최초마운트 여부 
    const [check1 , setCheck1] = useState(0); // 마스터 재조회용 상태
    const [check2 , setCheck2] = useState(0); // 디테일 재조회용 상태 
    const [searchParam, setSearchParam] = useState({}); // 조회조건 상태
    const [menuDataArray, setMenuDataArray] = useState([]); // 조회조건 menu 배열
    const [itemDataArray, setItemDataArray] = useState([]); // 조회조건 item 배열 
    const [maseterReadOnly, setMaseterReadOnly] = useState(true); // 마스터 폼 readOnly 여부
    const [maseterBtnReadOnly, setMaseterBtnReadOnly] = useState(true); // 마스터 폼 버튼 readOnly 여부
    const [detailBtnReadOnly, setDetailBtnReadOnly] = useState(true); // 디테일 폼 버튼 readOnly 여부
    const [isAdding, setIsAdding] = useState(false); // 신규버튼 readonly여부 
    const [masterItem, setMasterItem] = useState({
        ARTCL_CD_UNQ_VL : null      // 항목 코드 고유값
        , ARTCL_CD : null           // 항목 코드
        , ARTCL_NM : null           // 항목명
        , ARTCL_EXPLN : null        // 항목 설명
        , ARTCL_EXAMPLE_CD : null   // 항목 예시 코드
        , USE_YN : null             // 사용 여부
        , REMK : null               // 비고
    }); // 마스터 아이템 
    const [detailItemList, setDetailItemList] = useState([]); // 디테일 아이템 리스트

    const detail_Grid_Columns = [
        { id: 'index', name: '순번', type: 'index'},
        { id: 'ATRB_NM', name: '속성명', readOnly: 'true', textAlign: 'center', required: true },
        { id: 'ATRB_TYPE', name: '속성타입', textAlign: 'center' },
        { id: 'ATRB_EXPLN', name: '속성설명', textAlign: 'left', width: '500' },
        { id: 'ATRB_EXAMPLE_VL', name: '속성예시값'},
        { id: 'ATRB_SEQ', name: '속성순번', textAlign: 'center'},
        { id: 'USE_YN', name: '사용여부', textAlign: 'center'},
        { id: 'REMK', name: '비고' },
        { id: 'delete', name: '삭제', type: 'button', label: '삭제' },
    ];

    // 그리드 onCellChange 이벤트 선언 
    const handleCellChange = ({ rowIndex, columnId, oldValue, newValue, updatedRow }) => {
        // 사용법
        // console.log(`[셀 변경] 행 ${rowIndex} / 컬럼: ${columnId}`);
        // console.log(`👉 이전 값: ${oldValue}`);
        // console.log(`👉 새로운 값: ${newValue}`);
        // console.log(`👉 전체 행 데이터:`, updatedRow);
    };

    useEffect(() => {
        if (!hasMounted) {
            setHasMounted(true);
            return;
        }
        S_01();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [check1]);

    useEffect(() => {
        if (!hasMounted) {
            setHasMounted(true);
            return;
        }
        S_02();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [check2]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const resMenu = await axiosInstance.get("/common/findMenu");
                const resItem = await axiosInstance.get("/common/findItem");
                
                setMenuDataArray(resMenu.data);
                setItemDataArray(resItem.data);
            } catch (error) {
                console.error("초기 데이터 불러오기 실패", error);
            }
        };
        fetchInitialData();
        setSearchParam({
            SESSION_USER_ID : local.getItem("SESSION_USER_ID")
            , SESSION_USER_NAME : local.getItem("SESSION_USER_NAME")
        });
    }, []); // 의존성 배열이 비어 있음 → mount 시 1회만 실행

    // 마스터 조회
    const S_01 = async () => {
        try {
            const DocMngRes = await axiosInstance.get('/docMng/findDocMng', {
                params: {...searchParam}
            });
            
            DocMngRes.data.status = 'load';
            setMasterItem(DocMngRes.data);

            setDetailBtnReadOnly(false);
            setMaseterReadOnly(false);
            await S_02();

        } catch (error) {
            console.error('Error ComponentMaster - S_01', error)
        }
    };

    // 디테일 조회
    const S_02 = async () => {
        try {
            const DocMngResDtl = await axiosInstance.get('/docMngDtl/findDocMngDtl', {
                params: {...searchParam}
            });

            // 아이템 상태값 추가 
            DocMngResDtl.data.forEach(element => {
                element.status = 'load';
            });
            
            setDetailItemList(DocMngResDtl.data);
            setIsAdding(false);
            setMaseterBtnReadOnly(false);
        } catch (error) {
            console.error('Error ComponentMaster - S_02', error)
        }
    };

    // 신규추가 
    const addrow = async (type) => {
        
        if (type == 'master') {

            
            const res = await axiosInstance.get('/docMng/findMaxDocMngCnt', {
                params: {...searchParam}
            });
            const combindARTCL_CD = res.data;

            setMasterItem({
                ARTCL_CD_UNQ_VL: searchParam.ARTCL_CD_UNQ_VL,
                ARTCL_CD: combindARTCL_CD,
                ARTCL_NM: '',
                ARTCL_EXPLN: '',
                ARTCL_EXAMPLE_CD: '',
                USE_YN: 'Y',
                REMK: '',
                status: 'new'
            });
            setDetailItemList([])
            setIsAdding(true);
            setMaseterBtnReadOnly(false);
            setMaseterReadOnly(false);
        } else if (type == 'detail') {
            const newDetailItem = {
                ARTCL_CD: masterItem.ARTCL_CD,   // 마스터 기준 컬럼 코드
                ATRB_NM: '',                     // 초기값 비워두거나 기본 세팅
                ATRB_TYPE: '',
                ATRB_EXPLN: '',
                ATRB_SEQ: String(detailItemList.length + 1),  // 순번 설정
                USE_YN: 'Y',
                REMK: '',
                status: 'new' // 신규 플래그
            };

            setDetailItemList(prev => [...prev, newDetailItem]);

            setMaseterBtnReadOnly(true);
        }
    }
    
    // 마스터 저장
    const CU_01 = async () => {
        // const isNew = type === 'new';
        const isNew = masterItem.status == 'new'
        const confirmMessage = isNew ? "저장 하시겠습니까?" : "수정 하시겠습니까?";
        const successMessage = isNew ? "저장이 완료되었습니다." : "수정이 완료되었습니다.";
        const url = isNew ? '/docMng/createDocMng' : '/docMng/updateDocMng';
        const status = isNew ? 'new' : 'modify';

        try {
            const confirmRes = await confirm({body : confirmMessage});

            if (!confirmRes) return;
        
            await axiosInstance.post(url, { 
                ...masterItem 
                , status
            });
            await alert({body : successMessage});
            
            const resItem = await axiosInstance.get("/common/findItem");      
            setItemDataArray(resItem.data); 

            if (status == 'new') {
                setSearchParam({
                    ARTCL_CD_UNQ_VL : masterItem.ARTCL_CD_UNQ_VL
                    , ARTCL_CD : masterItem.ARTCL_CD
                });
            }

            // 재조회 
            setCheck1(check1+1);

        } catch (error) {
            console.error(`Error ComponentMaster - ${isNew ? 'C_01' : 'U_01'}`, error);
        }
    };

    // 삭제
    const D_01 = async () => {
        try {
            // 상태 유효성 검사
            const status = masterItem.status;
            if (status == 'new') {
                await alert({body : "작성중인 데이터가 있습니다."});
                return;
            }
            
            // 컨펌 메세지
            const confirmRes = await confirm({body : "삭제 하시겠습니까?"});
            if (!confirmRes) return;
            
            // 쿼리 요청
            await axiosInstance.post('/docMng/deleteDocMng', {...masterItem});
            
            // 완료 메세지
            await alert({body : "삭제가 완료되었습니다."});
            
            // 삭제 후 searchParam 메뉴 재조회
            const resItem = await axiosInstance.get("/common/findItem");      
            setItemDataArray(resItem.data); 
            
            // searhParam을 이전 삭제 시 값으로 대입 
            setSearchParam({
                ARTCL_CD_UNQ_VL : masterItem.ARTCL_CD_UNQ_VL
            });

            // 재조회 
            setCheck1(check1+1);
        } catch (error) {
            console.error('Error ComponentMaster - D_01', error)
        }
    };
    
    // 디테일 저장
    const CU_02 = async () => {
        try {
            if(detailItemList.length > 0) {
                for(let i = 0; i < detailItemList.length; i++){
                    if(!detailItemList[i].ATRB_NM || detailItemList[i].ATRB_NM.trim() === ""){
                        await alert({body : "속성명을 입력해주세요."})
                        return;
                    }
                }
            }
            
            const confirmRes = await confirm({body : "저장 하시겠습니까?"});
            if (!confirmRes) return;
            
            await axiosInstance.post('/docMngDtl/createDocMngDtl', detailItemList);
            await alert({body : "저장이 완료되었습니다."});
            
            // searhParam을 이전 삭제 시 값으로 대입 
            setSearchParam({
                ARTCL_CD_UNQ_VL : masterItem.ARTCL_CD_UNQ_VL
                , ARTCL_CD : masterItem.ARTCL_CD
            });

            // 재조회 
            setCheck2(check2+1);
            
        } catch (error) {
            console.error(`Error ComponentDetail - CU_02`, error);
        }
    };

    // 디테일 삭제
    const D_02 = async (idx) => {
        try {
            const element = detailItemList[idx];
            
            if (element.status === "new") {
                const newList = [...detailItemList];
                newList.splice(idx, 1);
                setDetailItemList(newList);
                return; // 서버 요청 없이 종료
            }

            // 컨펌 메세지
            const confirmRes = await confirm({body : "삭제 하시겠습니까?"});
            if (!confirmRes) return;

            

            // 쿼리 요청
            await axiosInstance.post('/docMngDtl/deleteDocMngDtl', {...element});
            
            // 완료 메세지
            await alert({body : "삭제가 완료되었습니다."});
            
            // searhParam을 이전 삭제 시 값으로 대입 
            setSearchParam({
                ARTCL_CD_UNQ_VL : masterItem.ARTCL_CD_UNQ_VL
                , ARTCL_CD : masterItem.ARTCL_CD
            });

            // 재조회 
            setCheck2(check2+1);
        } catch (error) {
            console.error('Error ComponentMaster - D_02', error)
        }
    };

    // 그리드 셀 클릭
    const gridOnCellClick = async ({ info }) => {
        let colId = info.columnId
        let rowIndex = info.rowIndex

        if (colId == 'delete') {
            D_02(rowIndex);
        }
    }
    
return (
    <div className="shuriken before:content-[''] before:z-[-1] before:w-screen before:h-screen before:bg-slate-50 before:top-0 before:fixed before:bg-texture-black before:bg-contain before:bg-fixed before:bg-[center_-20rem] before:bg-no-repeat">
        {/* 관리자 네비게이션 */}
        <MngrNavi pgmId="DocMng" />
        <section>
            <h1>문서관리</h1>
            <div className="form_container" style={{ margin: "20px 0 0" }}>
                <div className="form_group" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", margin: 0 }}>
                    <div className="select-form" style={{ display: "flex", gap: 10, justifyContent: "flex-start", alignItems: "center" }}>
                    <label style={{ minWidth: 120 }}>메뉴 및 항목구분</label>
                        <Select
                            id="ARTCL_CD_UNQ_VL"
                            bind={searchParam}
                            setBind={setSearchParam}
                            data={menuDataArray}
                            label="KOR_FMY_NM" value="DETAIL_CODE"
                            minWidth={120}
                        ></Select>
                        <Select
                            id="ARTCL_CD"
                            bind={searchParam}
                            setBind={setSearchParam}
                            data={itemDataArray}
                            label="KOR_FMY_NM" value="DETAIL_CODE"
                            width={200}
                            minWidth={120}
                            filterTrigger={searchParam.ARTCL_CD_UNQ_VL}
                            filter={(item, trigger) => item.ARTCL_CD_UNQ_VL === trigger}
                        ></Select>
                    </div>
                    <div className="form_group" style={{ margin: 5 }}>
                        <button className="n_btn color_btn" onClick={S_01}>조회</button>
                    </div>
                </div>
            </div>

            <div className="boxwrap" style={{ display: "flex", gap: 40, width: "100%", flexDirection: "column" }}>
                {/* 마스터 */}
                <div className="notice_table" style={{ flexGrow: 1 }}>
                <div className="n_tit">
                    <h2>항목구분</h2>
                    <div style={{ display: "flex", gap: 8 }}>
                    <button className={`n_btn ${isAdding ? 'disabled-btn' : ''}`} disabled={isAdding} onClick={() => addrow('master')}>신규</button>
                        <button className="n_btn color_btn" disabled={maseterBtnReadOnly} onClick={() => D_01()}>삭제</button>
                        <button className="n_btn color_btn" disabled={maseterBtnReadOnly} onClick={() => CU_01()}>저장</button>
                    </div>
                </div>
                <table>
                    <tbody>
                    <tr>
                        <th>항목코드</th>
                        <td>
                            <Input 
                                bind = {masterItem}
                                setBind = {setMasterItem}
                                id = {"ARTCL_CD"}
                                maxLength={10}
                                placeHolder="항목 코드"
                                readOnly={true}
                            ></Input>
                        </td>
                        <th>항목명</th>
                        <td>
                            <Input 
                                bind = {masterItem}
                                setBind = {setMasterItem}
                                id = {"ARTCL_NM"}
                                maxLength={100}
                                placeHolder="항목명"
                                readOnly={maseterReadOnly}
                            ></Input>
                        </td>
                    </tr>
                    <tr>
                        <th>항목설명</th>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                            <Input 
                                bind = {masterItem}
                                setBind = {setMasterItem}
                                id = {"ARTCL_EXPLN"}
                                maxLength={200}
                                placeHolder="항목 설명"
                                readOnly={maseterReadOnly}
                                // width="400"
                            ></Input>
                        </td>
                        </tr>
                    <tr>
                        <th>항목 예시코드</th>
                        <td colSpan={3} style={{ textAlign: "left" }}>
                            <Input 
                                bind = {masterItem}
                                setBind = {setMasterItem}
                                id = {"ARTCL_EXAMPLE_CD"}
                                maxLength={3000}
                                placeHolder="항목 예시 코드"
                                type="textarea"
                                readOnly={maseterReadOnly}
                            ></Input>
                        </td>
                        </tr>
                    <tr>
                        <th>사용여부</th>
                        <td>
                            <Select
                                id="USE_YN"
                                bind={masterItem}
                                setBind={setMasterItem}
                                data={[
                                    {"KOR_FMY_NM": "Y","DETAIL_CODE": "Y"}
                                    , {"KOR_FMY_NM": "N","DETAIL_CODE": "N"}
                                ]}
                                label="KOR_FMY_NM" value="DETAIL_CODE"
                                width="60"
                                readOnly={maseterReadOnly}
                            ></Select>
                        </td>
                        <th>비고</th>
                        <td>
                            <Input 
                                bind = {masterItem}
                                setBind = {setMasterItem}
                                id = {"REMK"}
                                maxLength={500}
                                placeHolder="비고"
                                readOnly={maseterReadOnly}
                            ></Input>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>

                {/* 속성 */}
                <div className="notice_table" style={{ flexGrow: 2 }}>
                <div className="n_tit">
                    <h2>속성 목록</h2>
                    <div style={{ display: "flex", gap: "8px" }}>
                        <button className="n_btn" disabled={detailBtnReadOnly} onClick={() => addrow('detail')}>신규</button>
                        <button className="n_btn color_btn" disabled={detailBtnReadOnly} onClick={() => CU_02()}>저장</button>
                    </div>
                </div>
                <DataGridMUI
                    columns={detail_Grid_Columns}
                    data={detailItemList}
                    setBind={setDetailItemList}
                    pk="ATRB_NM" // 고유키 지정
                    onCellClick={info => gridOnCellClick(info)}
                    onCellChange={handleCellChange}
                ></DataGridMUI>
                </div>
            </div>
        </section>
    </div>
    );
};

export default DocMng;
